// boequantitybreaks.js · "בחרי יותר. שלמי פחות"
//
// מחליף את חלונית מדרגות הכמות של Adoric Bundles.
//
// ההנחה עצמה לא תלויה בקובץ הזה: היא הנחה אוטומטית של שופיפיי, אחת לכל מוצר,
// שיורדת בעגלה גם בלי שהלקוחה תיגע כאן. כלומר אם הסקריפט ייפול, מי שתשים שלושה
// עדיין תקבל 10%. זה ההבדל בין חלונית שמבטיחה הנחה לחלונית שמשקפת אותה.
//

const DATA_EL = "boe-qb-data";

const money = (agorot) =>
  "₪" + (agorot / 100).toLocaleString("he-IL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const CSS = `
.boe-qb{direction:rtl;text-align:right;margin:16px 0;font-family:inherit}
.boe-qb__h{text-align:center;font-size:16px;font-weight:600;color:#705251;margin:0 0 12px}
.boe-qb__list{display:flex;flex-direction:column;gap:8px}
.boe-qb__row{padding:12px 14px;border:1px solid #00000029;border-radius:6px;background:#ffffff00;
  cursor:pointer;transition:border-color .15s,background .15s}
.boe-qb__row[aria-checked="true"]{border-width:2px;border-color:#705251;background:#fff}
.boe-qb__main{display:flex;align-items:center;gap:12px}
.boe-qb__radio{flex:0 0 auto;width:18px;height:18px;border-radius:50%;border:2px solid #00000029;position:relative}
.boe-qb__row[aria-checked="true"] .boe-qb__radio{border-color:#705251}
.boe-qb__row[aria-checked="true"] .boe-qb__radio::after{content:"";position:absolute;inset:3px;border-radius:50%;background:#705251}
.boe-qb__text{flex:1 1 auto;min-width:0}
.boe-qb__t{display:block;font-size:15px;font-weight:600;color:#3A2F25;line-height:1.3}
.boe-qb__pct{font-weight:500;font-size:13px;color:#8A6F5C}
.boe-qb__s{display:block;font-size:12px;color:#8A6F5C;margin-top:3px}
.boe-qb__prices{flex:0 0 auto;text-align:left}
.boe-qb__now{font-size:15px;font-weight:600;color:#3A2F25}
.boe-qb__was{font-size:12px;color:#9A8A7A;text-decoration:line-through}
.boe-qb__picks{margin:12px 0 0;display:none;flex-direction:column;gap:8px}
.boe-qb__row[aria-checked="true"] .boe-qb__picks{display:flex}
.boe-qb__pickslabel{font-size:12px;color:#8A6F5C;margin:0}
.boe-qb__pick{display:flex;align-items:center;gap:8px}
.boe-qb__num{flex:0 0 auto;font-size:13px;font-weight:700;color:#705251;min-width:24px}
.boe-qb__sel{flex:1 1 0;min-width:0;padding:8px 10px;border:1px solid #00000029;border-radius:6px;
  background:#fff;font-family:inherit;font-size:13px;color:#3A2F25;
  text-overflow:ellipsis}
`;

function injectCss() {
  if (document.getElementById("boe-qb-css")) return;
  const s = document.createElement("style");
  s.id = "boe-qb-css";
  s.textContent = CSS;
  document.head.appendChild(s);
}

const productForm = () => document.querySelector('form[action*="/cart/add"]:not(.installment)');

function currentVariantId() {
  const fromUrl = new URLSearchParams(location.search).get("variant");
  if (fromUrl) return String(fromUrl).replace(/\D/g, "");
  const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
  return input ? String(input.value).replace(/\D/g, "") : "";
}

const anchor = () =>
  document.querySelector("buy-buttons:not([class*=hidden])") ||
  document.querySelector("buy-buttons") ||
  productForm();

// מדרגה נכנסת רק אם אפשר באמת לקנות אותה. stock===null הוא מלאי לא מוגבל.
const usableTiers = (tiers, v) =>
  !v || !v.available ? [] : tiers.filter((t) => v.stock === null || v.stock >= t.qty);

/* ===================== בוררי המידה והצבע לכל פריט ===================== */

function buildPickRow(state, index) {
  const { data } = state;
  const wrap = document.createElement("div");
  wrap.className = "boe-qb__pick";
  wrap.innerHTML = `<span class="boe-qb__num">#${index + 1}</span>`;

  const selects = data.optionNames.map((name, oi) => {
    const sel = document.createElement("select");
    sel.className = "boe-qb__sel";
    sel.setAttribute("aria-label", name);
    // רק ערכים שיש להם וריאנט זמין. ערך שאין לו אף צירוף קיים לא מוצג בכלל,
    // כדי שלא ייווצר מצב שבוחרים ואז מגלים שהצירוף לא קיים.
    const values = [...new Set(data.variants.filter((v) => v.available).map((v) => v.options[oi]))];
    for (const val of values) {
      const o = document.createElement("option");
      o.value = val;
      o.textContent = val;
      sel.appendChild(o);
    }
    // רוחב לפי אורך הערך הארוך ביותר: "מידה" צריכה מעט מקום ו"צבע" הרבה, ובלי זה
    // ערך כמו chocolate brown נחתך. חלוקה לפי תוכן ולא מספרים קשיחים, כדי שזה
    // יחזיק גם במוצר עם שמות אפשרויות אחרים לגמרי.
    sel.style.flexGrow = String(Math.max(1, ...values.map((v) => String(v).length)));
    sel.addEventListener("change", () => resolve(state, index, oi));
    wrap.appendChild(sel);
    return sel;
  });

  state.rows[index] = { wrap, selects, variantId: null };
  return wrap;
}

// בוררים תלויים זה בזה: אחרי בחירת מידה, רשימת הצבעים נבנית מחדש ומכילה רק
// צבעים שקיימים באמת באותה מידה.
//
// 05/10: קודם כל בורר הציג את כל הערכים בנפרד, ואז "S" ו"שחור" שניהם הופיעו אבל
// S/שחור אזל. הקוד היה מחליק בשקט לוריאנט זמין אחר, כלומר הלקוחה בוחרת דבר אחד
// ומקבלת אחר. עדיף שערך שאי אפשר לקנות פשוט לא יופיע.
function constrain(state, index, changedIndex) {
  const { data } = state;
  const row = state.rows[index];
  if (!row) return;
  const pinned = changedIndex == null ? null : row.selects[changedIndex].value;

  row.selects.forEach((sel, oi) => {
    if (oi === changedIndex) return;
    const valid = [
      ...new Set(
        data.variants
          .filter((v) => v.available && (pinned == null || v.options[changedIndex] === pinned))
          .map((v) => v.options[oi]),
      ),
    ];
    if (!valid.length) return;
    const keep = sel.value;
    sel.innerHTML = "";
    for (const val of valid) {
      const o = document.createElement("option");
      o.value = val;
      o.textContent = val;
      sel.appendChild(o);
    }
    sel.value = valid.indexOf(keep) >= 0 ? keep : valid[0];
    sel.style.flexGrow = String(Math.max(1, ...valid.map((v) => String(v).length)));
  });
}

// אחרי ההצרה, מוצאים את הוריאנט המדויק. בשלב הזה הוא תמיד אמור להימצא.
function resolve(state, index, changedIndex) {
  const { data } = state;
  const row = state.rows[index];
  if (!row) return;
  constrain(state, index, changedIndex);
  const wanted = row.selects.map((s) => s.value);
  const match = data.variants.find(
    (v) => v.available && v.options.every((o, i) => o === wanted[i]),
  );
  row.variantId = match ? String(match.id) : null;
}

function setRowToVariant(state, index, variant) {
  const row = state.rows[index];
  if (!row || !variant) return;
  row.selects.forEach((s, i) => (s.value = variant.options[i]));
  // מצרים לפי האפשרות הראשונה (המידה), כך שגם שורה טרייה לא מציעה צירוף שאזל
  constrain(state, index, 0);
  row.selects.forEach((s, i) => {
    if (variant.options[i] && [...s.options].some((o) => o.value === variant.options[i])) {
      s.value = variant.options[i];
    }
  });
  const wanted = row.selects.map((s) => s.value);
  const match = state.data.variants.find(
    (v) => v.available && v.options.every((o, i) => o === wanted[i]),
  );
  row.variantId = match ? String(match.id) : String(variant.id);
}

/* ===================== הוספה לעגלה ===================== */

async function addPicks(state) {
  const picks = state.rows.slice(0, state.qty).map((r) => r && r.variantId).filter(Boolean);
  if (picks.length !== state.qty) {
    window.location.href = "/cart";
    return;
  }

  const items = [];
  for (const id of picks) {
    const hit = items.find((i) => i.id === Number(id));
    if (hit) hit.quantity += 1;
    else items.push({ id: Number(id), quantity: 1 });
  }

  try {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (!r.ok) throw new Error("add failed");
  } catch {
    window.location.href = "/cart";
    return;
  }

  // התבנית מנהלת מגירת עגלה משלה. מרעננים ופותחים דרך האירועים שהיא מקשיבה
  // להם, ואם זה לא תופס נופלים לעמוד העגלה, שתמיד עובד.
  for (const name of ["cart:refresh", "cart:change", "cart:updated", "variant:added"]) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
  }
  const drawer = document.querySelector("cart-drawer");
  if (drawer && typeof drawer.show === "function") {
    try {
      drawer.show();
      return;
    } catch {
      /* נופלים לעמוד העגלה */
    }
  }
  window.location.href = "/cart";
}

function hookAddToCart(state) {
  const form = productForm();
  if (!form || form.dataset.boeQbHooked) return;
  form.dataset.boeQbHooked = "1";
  form.addEventListener(
    "submit",
    (e) => {
      // מדרגת היחיד היא הזרימה הרגילה של התבנית. לא נוגעים בה.
      if (!state.active || state.qty < 2) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addPicks(state);
    },
    true,
  );
}

/* ===================== ציור ===================== */

function select(state, box, qty) {
  const variant = state.byId[currentVariantId()];
  box.dataset.qty = String(qty);
  state.qty = qty;

  const rows = [...box.querySelectorAll(".boe-qb__row")];
  rows.forEach((r) => r.setAttribute("aria-checked", String(Number(r.dataset.qty || 1) === qty)));

  // הבוררים נבנים רק למדרגה שנבחרה, וכולם מתחילים במה שכבר נבחר בעמוד.
  // זו ההחלטה של דליה: שלושתן זהות לבחירה הנוכחית, ומי שרוצה משנה.
  const active = rows.find((r) => Number(r.dataset.qty || 1) === qty);
  state.rows = [];
  if (active && qty > 1) {
    const picks = active.querySelector(".boe-qb__picks");
    [...picks.querySelectorAll(".boe-qb__pick")].forEach((n) => n.remove());
    for (let i = 0; i < qty; i++) {
      picks.appendChild(buildPickRow(state, i));
      setRowToVariant(state, i, variant);
    }
  }

  // הכמות בטופס נשארת 1: ההוספה של כמה פריטים נעשית דרך addPicks, ואם הסקריפט
  // לא תפס מסיבה כלשהי, עדיף שהלקוחה תוסיף אחד מאשר שלושה שלא בחרה.
  const qi = productForm() && productForm().querySelector('[name="quantity"]');
  if (qi && qi.value !== "1") {
    qi.value = "1";
    qi.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

function render(state) {
  const { data } = state;
  const variant = state.byId[currentVariantId()];
  const host = anchor();
  if (!host) return;

  const tiers = usableTiers(data.tiers, variant);
  const existing = document.getElementById("boe-qb");
  if (tiers.length < 2) {
    if (existing) existing.remove();
    document.documentElement.classList.remove("boe-qb-on");
    state.active = false;
    return;
  }
  state.active = true;
  document.documentElement.classList.add("boe-qb-on");

  let box = existing;
  if (!box) {
    box = document.createElement("div");
    box.id = "boe-qb";
    box.className = "boe-qb";
    box.innerHTML = `<p class="boe-qb__h"></p><div class="boe-qb__list" role="radiogroup"></div>`;
    host.insertAdjacentElement("beforebegin", box);
  }
  box.querySelector(".boe-qb__h").textContent = data.heading;

  const prevQty = Number(box.dataset.qty || tiers[0].qty);
  const qty = tiers.some((t) => t.qty === prevQty) ? prevQty : tiers[0].qty;

  const list = box.querySelector(".boe-qb__list");
  list.innerHTML = "";
  state.rows = [];

  for (const t of tiers) {
    const full = variant.price * t.qty;
    const now = Math.round(full * (1 - t.percent / 100));
    const saved = full - now;
    const row = document.createElement("div");
    row.className = "boe-qb__row";
    row.setAttribute("role", "radio");
    row.setAttribute("tabindex", "0");
    row.dataset.qty = String(t.qty);
    row.innerHTML = `
      <div class="boe-qb__main">
        <span class="boe-qb__radio"></span>
        <span class="boe-qb__text">
          <span class="boe-qb__t">${t.title}${
            t.percent ? ` <span class="boe-qb__pct">· ${t.percent}% הנחה</span>` : ""
          }</span>
          <span class="boe-qb__s">${
            t.percent
              ? t.subtitle
                  .replace("%PERCENT%", t.percent + "%")
                  .replace("%AMOUNT%", "<bdi>" + money(saved) + "</bdi>")
              : t.subtitle
          }</span>
        </span>
        <span class="boe-qb__prices">
          <span class="boe-qb__now">${money(now)}</span>
          ${t.percent ? `<br><span class="boe-qb__was">${money(full)}</span>` : ""}
        </span>
      </div>`;

    if (t.qty > 1) {
      const picks = document.createElement("div");
      picks.className = "boe-qb__picks";
      const label = document.createElement("p");
      label.className = "boe-qb__pickslabel";
      label.textContent = data.optionNames.join(", ");
      picks.appendChild(label);
      row.appendChild(picks);
    }

    row.addEventListener("click", (e) => {
      if (e.target.closest(".boe-qb__sel")) return; // קליק על בורר לא משנה מדרגה
      select(state, box, t.qty);
    });
    row.addEventListener("keydown", (e) => {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        select(state, box, t.qty);
      }
    });
    list.appendChild(row);
  }

  select(state, box, qty);
  hookAddToCart(state);
}

/* ===================== הפעלה ===================== */

function start() {
  const el = document.getElementById(DATA_EL);
  if (!el) return;
  let data;
  try {
    data = JSON.parse(el.textContent);
  } catch {
    return;
  }
  injectCss();

  const byId = {};
  for (const v of data.variants) byId[String(v.id)] = v;
  const state = { data, byId, rows: [], qty: 1, active: false };

  let last = null;
  const sync = () => {
    const id = currentVariantId();
    if (id === last) return;
    last = id;
    render(state);
  };
  sync();

  new MutationObserver(sync).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["value", "data-variant-id", "selected"],
  });
  window.addEventListener("popstate", () => {
    last = null;
    sync();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
